import React from 'react';
import '../../styles/Signup.css';
import SignupForm from './SignupForm';
import signupImage from '../../images/signup.jpg';

const Signup: React.FC = () => {
  return (
    <div className="signup-container">
      <div className="signup-row row g-0">
        {/* Image Column */}
        <div className="signup-image-col col-md-6">
          <img
            src={signupImage}
            alt="People signing up"
            className="signup-image img-fluid"
          />
        </div>

        {/* Form Column */}
        <div className="signup-form-col col-md-6 d-flex align-items-center justify-content-center">
          <div className="signup-box bg-white rounded-4 shadow-sm">
            <h3 className="text-center pt-3 pb-2 fw-semibold">
              Create Account
            </h3>
            <hr className="mx-4" />
            <SignupForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
